import { GuidEmpty } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared@models';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { ProxmoxFormModel } from 'wizards/models/proxmox/proxmox-form-model';
import { VmwareFormModel } from 'wizards/models/VMWare/vmware-form-model';

export class ProxmoxModelForStepsHelper extends BaseForStepsHelper {
  public static ProxmoxModel: ProxmoxFormModel = null;

  public static ProxmoxModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): ProxmoxFormModel {
    const newPlan = plan && (plan.plan || plan.Plan);
    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.ConnectionID);
      this.ProxmoxModel = new VmwareFormModel(this.isUnix);

      this.updatePlanNameStep(newPlan, settings.compName);
      this.updateWhereBackupStep(newPlan, settings);
      this.ProxmoxModel.compressionEncryptionStep = StepsDataFromPlanHelper.updateCompressionEncryption(
        newPlan,
        this.isNBF,
        this.isUnix,
        this.isCreate,
        true
      );

      this.ProxmoxModel.selectHostStep = StepsDataFromPlanHelper.updateSelectHost(newPlan, !this.isCreate);
      this.ProxmoxModel.selectVirtualMachinesStep = StepsDataFromPlanHelper.updateSelectVirtualMachines(newPlan, true);

      this.ProxmoxModel.advancedSettingsStep = StepsDataFromPlanHelper.updateAdvancedSettingsVirtual(
        newPlan,
        this.storage,
        this.isCreate,
        false,
        settings?.agentVersion
      );

      this.bucketId = this.accounts && this.isRD ? this.getBucketId(newPlan.Bucket, newPlan.SGAccountID) : newPlan.ConnectionID;

      this.ProxmoxModel.archiveConsistencyStep = StepsDataFromPlanHelper.updateArchiveConsistency(newPlan);
      this.ProxmoxModel.scheduleStep = StepsDataFromPlanHelper.updateNBFSchedule(
        newPlan,
        plan.OverdueAfterSuccess,
        this.isCreate,
        this.isUnix,
        settings.isNBF,
        settings.validVersionForSchedule
      );
      this.ProxmoxModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFRetentionPolicy(
        newPlan,
        SupportMethodsForStepsFromPlan.needShowImmutability(this.storages.CloudStorages, this.bucketId),
        this.isCreate,
        this.isUnix,
        this.isNBF
      );

      if (this.nbfCanHybrid && !!newPlan.HybridConnections?.length) {
        this.ProxmoxModel.retentionPolicyStep = StepsDataFromPlanHelper.updateNBFHybridRetentionPolicy(
          newPlan,
          this.ProxmoxModel.retentionPolicyStep
        );
      }

      this.ProxmoxModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan);
      this.ProxmoxModel.notificationStep = StepsDataFromPlanHelper.updateNotification(newPlan.Notification);

      if (!this.isUnix) {
        this.ProxmoxModel.AvailableMachinePlans = StepsDataFromPlanHelper.updateAvailableMachinePlans(
          plan.AvailableMachinePlans,
          newPlan.ID
        );
      }
    }
    return this.ProxmoxModel;
  }

  public static updatePlanNameStep(newPlan, compName: string): void {
    const name = newPlan.Name || SupportMethodsForStepsFromPlan.generatePlanName(compName, this.planType, this.timeZoneOffset);
    this.ProxmoxModel.planNameStep = StepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.SavePlanInCloud, this.isNBF);
  }

  public static updateWhereBackupStep(newPlan, settings: WizardHelpersSettings): void {
    if (!this.accounts) {
      this.updateWhereBackupStepData(newPlan, this.ProxmoxModel, settings);
    } else {
      const id = this.bucketId || this.getBucketId(newPlan.Bucket, newPlan.SGAccountID);

      this.updateWhereBackupStepData(newPlan, this.ProxmoxModel, settings, id);

      if (id && id !== GuidEmpty) {
        const storage = this.storages.CloudStorages.find((s) => s.ID === id) || this.storages.LocalStorages.find((s) => s.ID === id);
        this.storageType = storage ? storage.StorageType : this.storageType;
      }
    }

    if (!this.isRD) SupportMethodsForStepsFromPlan.getFilteredStoragesByTypes(this.storages, [StorageType.OpenStack]);

    this.ProxmoxModel.Storages = this.storages;
    this.ProxmoxModel.StoragesArray = [...this.storages.CloudStorages, ...this.storages.LocalStorages];
  }
}
